import * as React from 'react';

class PostalSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon postal-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M20 3.31672V13.0001C20 13.6631 19.7366 14.299 19.2678 14.7678C18.7989 15.2367 18.163 15.5001 17.5 15.5001H2.5C1.83696 15.5001 1.20107 15.2367 0.732233 14.7678C0.263392 14.299 0 13.6631 0 13.0001V3.35839C2.62854 6.03836 5.53365 8.43228 8.66667 10.5001C8.66667 10.5001 9.28333 10.9084 10 11.3334L10.4583 11.0417L11.2917 10.5001C14.3775 8.33664 17.2892 5.93485 20 3.31672V3.31672ZM8.66667 8.41672C8.66667 8.41672 9.28333 8.82505 10 9.25005C10.7167 8.82505 11.3333 8.41672 11.3333 8.41672C14.3157 6.38968 17.0436 4.01151 19.4583 1.33339C19.2188 1.05224 18.9172 0.830611 18.5773 0.685991C18.2375 0.54137 17.8687 0.477717 17.5 0.500055H2.5C2.12845 0.473738 1.75593 0.535493 1.41274 0.680297C1.06956 0.825101 0.765397 1.04886 0.525 1.33339C2.94611 4.01134 5.6795 6.38941 8.66667 8.41672V8.41672Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default PostalSvg;
